import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { EscaLandingPage } from './pages/EscaLandingPage';
import { EscaClassicPage } from './pages/EscaClassicPage';
import { ExecutiveSearchPage } from './pages/services/ExecutiveSearchPage';
import { ITRecruitmentPage } from './pages/services/ITRecruitmentPage';
import { TeamBuildingPage } from './pages/services/TeamBuildingPage';
import { CareerConsultingPage } from './pages/services/CareerConsultingPage';
import { LanguageProvider } from './context/LanguageContext';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);
  return null;
}
function SmoothAnchorScroll() {
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href*="#"]') as HTMLAnchorElement | null;
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!href) return;
      // Extract the hash part
      const hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;
      const hash = href.substring(hashIndex);
      if (!hash || hash === '#') return;
      // Only handle same-page anchors
      const hrefPath = href.substring(0, hashIndex) || '/';
      const currentPath = window.location.pathname;
      if (hrefPath !== '/' && hrefPath !== currentPath && hrefPath !== '/#') {
        // Cross-page anchor — let router handle it
        return;
      }
      const el = document.querySelector(hash);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  return null;
}
export function App() {
  useEffect(() => {
    // Google Tag Manager - head script
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MZP5VWQ');`;
    document.head.insertBefore(script, document.head.firstChild);
    // Google Tag Manager - noscript body
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-MZP5VWQ';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);
  return <LanguageProvider data-id="element-0" data-mp="18cq5ljp6gese">
      <BrowserRouter data-id="element-1" data-mp="18c6lbwc21eb7">
        <ScrollToTop data-id="element-2" data-mp="18byasb3eml36" />
        <SmoothAnchorScroll data-id="element-3" data-mp="1d47yrlkylb2t" />
        <Routes data-id="element-4" data-mp="1d5j8s34zzf2d">
          <Route path="/" element={<EscaClassicPage data-id="element-6" data-mp="1d6awysw9maim" />} data-id="element-5" data-mp="1d62hct8rcr3q" />
          <Route path="/first-main" element={<LandingPage data-id="element-8" data-mp="yh6dl8dqi08x" />} data-id="element-7" data-mp="yg3l4w0rjpqw" />
          <Route path="/esca" element={<EscaLandingPage data-id="element-10" data-mp="13e55rldu7x4h" />} data-id="element-9" data-mp="ydqvdworkb3a" />
          {/* Legacy URL kept so existing links to the classic layout still resolve */}
          <Route path="/esca-classic" element={<EscaClassicPage data-id="element-12" data-mp="1r529wbze5q56" />} data-id="element-11" data-mp="1r5ak1w44qhco" />
          <Route path="/services/executive-search" element={<ExecutiveSearchPage data-id="element-14" data-mp="1w19cpvwhqliw" />} data-id="element-13" data-mp="1w33qmq9chddh" />
          <Route path="/services/it-recruitment" element={<ITRecruitmentPage data-id="element-16" data-mp="1m5617zfr1aja" />} data-id="element-15" data-mp="1i4ccj3uhfrpc" />
          <Route path="/services/team-building" element={<TeamBuildingPage data-id="element-18" data-mp="6nw59xt30hdk" />} data-id="element-17" data-mp="1m3uym2y1i8tr" />
          <Route path="/services/career-consulting" element={<CareerConsultingPage data-id="element-20" data-mp="ar28ewkwdsft" />} data-id="element-19" data-mp="6mum161wwokr" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}